import { Base } from '@studiometa/js-toolkit';

/**
 * WysiwygTable class
 * Clones <th> items of <table> in every <td> in mobile.
 */
export default class WysiwygTable extends Base {
  static config = {
    name: 'WysiwygTable',
  };

  /**
   * Mounted
   */
  mounted() {
    const thElements = Array.from(this.$el.querySelectorAll('thead tr th'));
    if (!thElements || thElements.length <= 0) {
      return;
    }

    const trElements = Array.from(this.$el.querySelectorAll('tbody tr'));
    if (!trElements || trElements.length < 0) {
      return;
    }

    trElements.forEach((trElement) => {
      const tdElements = Array.from(trElement.querySelectorAll('td'));
      if (!tdElements || tdElements.length < 0) {
        return;
      }
      tdElements.forEach((tdElement, index) => {
        if (!thElements[index]) {
          return;
        }
        const element = document.createElement('strong');
        element.classList.add('mobile-th');
        element.setAttribute('aria-hidden', 'true');
        element.innerHTML = thElements[index].innerHTML;
        tdElement.prepend(element);
      });
    });
  }
}
